import { render } from "./ProjectView.vue?vue&type=template&id=18db0fb1&scoped=true"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=18db0fb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18db0fb1"]])

export default __exports__